import React, { useState, useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
import { t } from '../locales/translations';

const COUNTDOWN_KEY = 'lovago-promo-end';
const DURATION = 15 * 60; // 15 minutes in seconds

const getOrCreateEndTime = () => {
  const stored = localStorage.getItem(COUNTDOWN_KEY);
  if (stored) {
    const end = parseInt(stored, 10);
    if (end > Date.now()) return end;
  }
  const end = Date.now() + DURATION * 1000;
  localStorage.setItem(COUNTDOWN_KEY, String(end));
  return end;
};

const PromoBanner = () => {
  const { language } = useLanguage();
  const text = t[language].promoBanner;
  const endTimeRef = useRef(getOrCreateEndTime());
  const [timeLeft, setTimeLeft] = useState(
    Math.max(0, Math.floor((endTimeRef.current - Date.now()) / 1000))
  );

  useEffect(() => {
    const tick = () => {
      const remaining = Math.max(0, Math.floor((endTimeRef.current - Date.now()) / 1000));
      setTimeLeft(remaining);

      // Pause when tab is hidden (Page Visibility API)
      if (document.hidden) return;

      if (remaining <= 0) {
        // Reset countdown
        const newEnd = Date.now() + DURATION * 1000;
        endTimeRef.current = newEnd;
        localStorage.setItem(COUNTDOWN_KEY, String(newEnd));
      }
    };

    const timer = setInterval(tick, 1000);
    return () => clearInterval(timer);
  }, []);

  const minutes = Math.floor(timeLeft / 60).toString().padStart(2, '0');
  const seconds = (timeLeft % 60).toString().padStart(2, '0');

  return (
    <motion.div
      initial={{ y: -50, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="w-full bg-gradient-to-r from-orange-600 to-purple-700 text-white py-2 px-3 sm:px-4 text-center text-[11px] sm:text-sm font-bold flex flex-col sm:flex-row items-center justify-center gap-1 sm:gap-4 z-[60] relative shadow-lg"
    >
      <span>✨ {text.text}</span>
      <div className="bg-black/20 px-2 py-1 rounded border border-white/20 tabular-nums tracking-widest font-mono text-xs sm:text-sm">
        {minutes}:{seconds}
      </div>
    </motion.div>
  );
};

export default PromoBanner;